import { Head } from "@inertiajs/react"
import { CompanyLayout } from "~/components/company/CompanyLayout"

export default function Careers() {
  return (
    <CompanyLayout>
      <Head>
        <title>Careers | Join Our Team | Optimal Dev Labs</title>
        <meta name="description" content="Join Optimal Dev Labs. We're hiring talented developers to build modern web applications using React, Next.js, and Rails. View open positions and apply today." />
        <meta name="keywords" content="careers, jobs, developer jobs, react developer job, next.js jobs, rails developer, software engineer jobs, remote developer jobs" />
        <meta property="og:title" content="Careers | Join Our Team | Optimal Dev Labs" />
        <meta property="og:description" content="Join Optimal Dev Labs. We're hiring talented developers to build modern web applications using React, Next.js, and Rails." />
        <meta property="og:url" content="https://optimaldevlabs.com/careers" />
        <meta name="twitter:title" content="Careers | Join Our Team | Optimal Dev Labs" />
        <meta name="twitter:description" content="Join Optimal Dev Labs. We're hiring talented developers to build modern web applications." />
        <link rel="canonical" href="https://optimaldevlabs.com/careers" />
      </Head>
      <section className="w-full py-12 md:py-16 lg:py-20 bg-gray-50">
        <div className="container px-8 md:px-12 lg:px-16">
          <div className="flex flex-col items-center text-center space-y-6">
            <h1 className="text-3xl font-bold sm:text-4xl xl:text-5xl text-gray-900">Join Our Team</h1>
            <p className="max-w-[700px] text-gray-500 md:text-xl leading-relaxed">
              We are a Vietnam-US technology company building software products in the recruitment and HR space. Our
              team consists of managers based in the US and engineers in Vietnam, working together to build modern
              products for international clients.
            </p>
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-16 lg:py-20">
        <div className="container px-8 md:px-12 lg:px-16">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">Open Positions</h2>
          <p className="text-gray-500">There are no open positions at this time. Please check back later.</p>
        </div>
      </section>
    </CompanyLayout>
  )
}
